import React from 'react'
import { Box } from '@hub/box'
import { H3 } from '@hub/heading'
import { Link } from '@hub/link'
import { List, ListItem } from '@hub/list'
import { TermsModule } from '@scentregroup/shared/types/content-page'

interface TableOfContentsProps {
  sections: TermsModule[]
  title?: string
}

const TableOfContents: React.FunctionComponent<
  React.PropsWithChildren<TableOfContentsProps>
> = ({ sections, title = 'Table of Contents' }) => (
  <Box>
    <H3
      color="textPrimary"
      sx={{
        fontSize: ['font-xl', 'font-xl', 'font-2xl'],
        marginBottom: 'spacing-md',
      }}
    >
      {title}
    </H3>
    <List sx={{ gap: '8px' }}>
      {sections.map(section => (
        <ListItem key={section.title} sx={{ lineHeight: 'higher' }}>
          <Link
            title={section.title}
            hasUnderline
            href={`#${section.slug}`}
            target="_self"
          >
            {section.title}
          </Link>
        </ListItem>
      ))}
    </List>
  </Box>
)

export default TableOfContents
